import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {
        extensionPublicAPI: {dataManipulation, getter}
    } = publicMethodUtils
    return {
        methods: {
            mobileAlgo: {
                run: dataManipulation('mobileAlgo.run'),
                runForPage: dataManipulation('mobileAlgo.runForPage'),
                locking: {
                    unlockSectionsForAllPages: dataManipulation('mobileAlgo.locking.unlockSectionsForAllPages'),
                    unlockSectionsForPage: dataManipulation('mobileAlgo.locking.unlockSectionsForPage')
                },
                utils: {
                    getFontSize: getter('mobileAlgo.utils.getFontSize')
                }
            }
        }
    }
}
